import api from "Helpers/Api";
import { TBannerResponse } from "Services/Banners/banner";

export default async function bannerFetch(bannerId: string) {
  const { data } = await api.get<{ status: boolean; data: TBannerResponse }>(
    `/banners/${bannerId}`
  );
  return data;
}
